import { getAuthHeaders } from '../lib/supabase';
import { humanizeApiError } from '../lib/apiErrors';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

async function parseBody(response) {
  const text = await response.text();
  if (!text) return null;
  try { return JSON.parse(text); } catch (_) { return text; }
}

async function apiFetch(path, options = {}) {
  const authHeaders = options.auth === false ? {} : await getAuthHeaders();
  const response = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      ...authHeaders,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await parseBody(response);
  if (!response.ok) {
    const error = new Error(humanizeApiError(body, { context: 'default' }));
    error.status = response.status;
    error.payload = body;
    throw error;
  }
  return body;
}

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export async function fetchMasterProfile() {
  return apiFetch('/master-profile');
}

export async function analyzeStoredJob(jobId) {
  return apiFetch('/agent/analyze-stored-job', {
    method: 'POST',
    body: JSON.stringify({ job_id: jobId }),
  });
}

export async function refineStoredJob(jobId, result, answers) {
  return apiFetch('/agent/analyze-stored-job/refine', {
    method: 'POST',
    body: JSON.stringify({ job_id: jobId, submission_id: result?.submission_id, refinement_context_id: result?.refinement_context_id, refinement_answers: Object.entries(answers || {}).map(([refinement_id, value]) => ({ refinement_id, value: value || 'unknown' })) }),
  });
}

export async function fetchMyJobs() {
  const payload = await apiFetch('/my-jobs');
  return { items: asArray(payload?.items || payload) };
}

export async function updateMyJobState(jobResultId, state) {
  return apiFetch(`/my-jobs/${encodeURIComponent(jobResultId)}/state`, {
    method: 'PATCH',
    body: JSON.stringify({ state }),
  });
}

export async function fetchApplicationKitSummary() {
  return apiFetch('/application-kits/summary');
}

export function safeError(error, fallback = 'We could not load this right now. Please try again.') {
  return humanizeApiError(error, { context: 'default' }) || fallback;
}

export async function confirmMasterProfile(submissionId, expectedUpdatedAt) {
  return apiFetch(`/cv/${encodeURIComponent(submissionId)}/confirm-master-cv`, {
    method: 'POST',
    body: JSON.stringify({ expected_updated_at: expectedUpdatedAt }),
  });
}
